import React from 'react';
import { CheckIcon } from 'lucide-react';
import { addOns } from '../data/content';
import { HeroReel } from './HeroReel';
const addOnRows = [['Job or internship interviews', 'Personal brand'], ['Class or work presentations', 'Virtual communication'], ['Networking and outreach', 'Professional etiquette']];
const included = ["A dedicated coach located in Austin, TX", "Sessions on video, scheduled around class and work shifts", "Actionable tools and feedback", 'Async messaging when something urgent comes up'];
export function Coaching() {
  return <section id="coaching" className="bg-pearl-50 py-14 dark:bg-slate-950 sm:py-20" data-id="element-44" data-mp="3nbdtf1s878ms">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-45" data-mp="55hiqjf1ed5t">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-46" data-mp="4bqempagrwt">
          {/* Reel — left column on desktop, below the copy on smaller screens */}
          <div className="order-2 lg:order-1" data-id="element-47" data-mp="1gl65pasajc6m">
            <HeroReel data-id="element-48" data-mp="1bkrw3ob1ju6h" />
          </div>

          <div className="order-1 lg:order-2" data-id="element-49" data-mp="1bjqmzpdl5hre">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-50" data-mp="3szx5zek0wrfg">
              MEET YOUR COACH & UNDERSTAND THE PLAN
            </p>
            <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" style={{
            fontSize: "32px"
          }} data-id="element-51" data-mp="5uoa0fvm2wy0">
              One coach and a customized plan. 
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600 dark:text-slate-300 sm:text-lg" data-id="element-52" data-mp="39cpoh7vl35x5">
              From early career to management, Emberly Johnston founded Early Edge Coaching after years of corporate campus recruiting and managing early talent programs. Through her passion and expertise, Emberly designs development plans that enable students to discover their personal brand and confidence. 
            </p>

            <ul className="mt-7 space-y-3" data-id="element-53" data-mp="2qisrywmj2npo">
              {included.map(item => <li key={item} className="flex gap-3 text-slate-700 dark:text-slate-200" data-id="element-54" data-mp="2vioxj0avin7c">
                  <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-butter-200 text-butter-700 dark:bg-butter-500/30 dark:text-butter-300" data-id="element-55" data-mp="2ni8zg38hbibv">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="2x9de11u8t166" />
                  </span>
                  <span className="leading-relaxed" data-id="element-57" data-mp="2s9r0erai5iwu">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-slate-200 pt-6 dark:border-slate-800" data-id="element-58" data-mp="24lhhpy8l5b9x">
              <p className="text-center text-sm font-semibold text-slate-800 dark:text-pearl-100 lg:text-left" data-id="element-59" data-mp="20jmhyy6az5y9">
                Or grab just one thing:
              </p>
              {/* Desktop: original wrapped chip list */}
              <ul className="mt-3 hidden flex-wrap gap-2 lg:flex" data-id="element-60" data-mp="29hy4op41tjlf">
                {addOns.map(addOn => <li key={addOn.name} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 transition-colors hover:border-butter-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200" data-id="element-61" data-mp="3pwhkzccwbpkl">
                    {addOn.name}
                  </li>)}
              </ul>

              {/* Mobile: paired rows, centered */}
              <ul className="mt-3 grid grid-cols-2 gap-2 lg:hidden" data-id="element-62" data-mp="xqiazsle858z">
                {addOnRows.flat().map(name => <li key={name} className="flex items-center justify-center rounded-full border border-slate-200 bg-white px-3 py-2 text-center text-sm leading-snug text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200" data-id="element-63" data-mp="12p1yvyjjrr3z">
                    {name}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}